/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Dialog_Payment_Timeout_ContentInputs */

const en_dialog_payment_timeout_content = /** @type {(inputs: Dialog_Payment_Timeout_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your payment was not completed. 
Reason: ${i?.error}`)
};

const ar_dialog_payment_timeout_content = /** @type {(inputs: Dialog_Payment_Timeout_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`لم تكتمل عملية الدفع الخاصة بك. السبب: ${i?.error}`)
};

const de_dialog_payment_timeout_content = /** @type {(inputs: Dialog_Payment_Timeout_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ihre Zahlung wurde nicht abgeschlossen. Grund: ${i?.error}`)
};

const es_dialog_payment_timeout_content = /** @type {(inputs: Dialog_Payment_Timeout_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu pago no se completó. Motivo: ${i?.error}`)
};

const fr_dialog_payment_timeout_content = /** @type {(inputs: Dialog_Payment_Timeout_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre paiement n’a pas été finalisé. Raison : ${i?.error}`)
};

const it_dialog_payment_timeout_content = /** @type {(inputs: Dialog_Payment_Timeout_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo pagamento non è stato completato. Motivo: ${i?.error}`)
};

const ja_dialog_payment_timeout_content = /** @type {(inputs: Dialog_Payment_Timeout_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`お支払いが完了しませんでした。理由：${i?.error}`)
};

const ko_dialog_payment_timeout_content = /** @type {(inputs: Dialog_Payment_Timeout_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`결제가 완료되지 않았습니다. 사유: ${i?.error}`)
};

const pt_br_dialog_payment_timeout_content = /** @type {(inputs: Dialog_Payment_Timeout_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seu pagamento não foi concluído. Motivo: ${i?.error}`)
};

const ru_dialog_payment_timeout_content = /** @type {(inputs: Dialog_Payment_Timeout_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ваш платёж не был завершён. Причина: ${i?.error}`)
};

const th_dialog_payment_timeout_content = /** @type {(inputs: Dialog_Payment_Timeout_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`การชำระเงินของคุณไม่เสร็จสิ้น สาเหตุ: ${i?.error}`)
};

const tr_dialog_payment_timeout_content = /** @type {(inputs: Dialog_Payment_Timeout_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ödemeniz tamamlanmadı. Sebep: ${i?.error}`)
};

const zh_cn_dialog_payment_timeout_content = /** @type {(inputs: Dialog_Payment_Timeout_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你的付款未完成，原因是：${i?.error}`)
};

const zh_tw_dialog_payment_timeout_content = /** @type {(inputs: Dialog_Payment_Timeout_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你的付款未成功，原因是：
${i?.error}`)
};

/**
* | output |
* | --- |
* | "Your payment was not completed. Reason: {error}" |
*
* @param {Dialog_Payment_Timeout_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_payment_timeout_content = /** @type {((inputs: Dialog_Payment_Timeout_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Payment_Timeout_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_payment_timeout_content(inputs)
	if (locale === "ar") return ar_dialog_payment_timeout_content(inputs)
	if (locale === "de") return de_dialog_payment_timeout_content(inputs)
	if (locale === "es") return es_dialog_payment_timeout_content(inputs)
	if (locale === "fr") return fr_dialog_payment_timeout_content(inputs)
	if (locale === "it") return it_dialog_payment_timeout_content(inputs)
	if (locale === "ja") return ja_dialog_payment_timeout_content(inputs)
	if (locale === "ko") return ko_dialog_payment_timeout_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_payment_timeout_content(inputs)
	if (locale === "ru") return ru_dialog_payment_timeout_content(inputs)
	if (locale === "th") return th_dialog_payment_timeout_content(inputs)
	if (locale === "tr") return tr_dialog_payment_timeout_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_payment_timeout_content(inputs)
	return zh_tw_dialog_payment_timeout_content(inputs)
});